import { AdWrapper } from './Styles';

import {
    Size,
    Breakpoint,
    ZPG_DFP_NETWORK,
    DFP_AD_UNIT,
    AD_UNIT_ROOTS,
    AD_UNIT_SECTION,
    AD_UNIT_PAGE,
    ADBRIDG_CLASS
} from './types';

type DeprecatedProps = {
    sizes: Size[];
    position: number;
    adUnitCode?:
        | DFP_AD_UNIT
        | [AD_UNIT_ROOTS, AD_UNIT_SECTION]
        | [AD_UNIT_ROOTS, AD_UNIT_SECTION, AD_UNIT_PAGE]
        | [AD_UNIT_ROOTS, AD_UNIT_SECTION, string];
    dfpNetworkId?: ZPG_DFP_NETWORK.ID;
    collapseEmpty?: boolean;
    uuid?: string;
};

export const AdbridgSlot: React.FC<
    {
        adbridgClass?: string;
        adbridgDataClass?: string;
        hasMarginTop?: boolean;
        height?: number;
        showOnly?: Breakpoint;
    } & DeprecatedProps
> = ({
    adbridgClass,
    adbridgDataClass,
    hasMarginTop = true,
    height,
    showOnly,
    sizes,
    position,
    uuid
}) => {
    const testid = `dfp_${
        typeof sizes[0] === 'string' ? sizes[0] : sizes[0].join('x')
    }_${position}${uuid ? `_${uuid}` : ''}`;

    const resolvedClass =
        adbridgDataClass === ADBRIDG_CLASS.ADB_TEXT_LINK
            ? adbridgDataClass
            : adbridgClass;

    return (
        <AdWrapper height={height} breakpoint={showOnly}>
            <div
                itemScope={true}
                itemType="https://schema.org/WPAdBlock"
                className="zad-slot"
                style={{
                    marginTop: hasMarginTop ? '16px' : 0,
                    width: '100%',
                    minHeight: `${height ?? 0}px`,
                    overflow: 'hidden'
                }}
                data-adbridg-ad-class={resolvedClass}
                data-testid={testid}
            />
        </AdWrapper>
    );
};
